"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unloadStyles = exports.filesAppender = exports.tagAppender = exports.createScriptElement = exports.createLinkElement = void 0;
var tslib_1 = require("tslib");
var ModuleRegistry_1 = require("./ModuleRegistry");
var ReactModuleContainerErrors_1 = require("./ReactModuleContainerErrors");
function noprotocol(url) {
    return url.replace(/^.*:\/\//, '//');
}
function createLinkElement(url) {
    var fileref = document.createElement('link');
    fileref.setAttribute('rel', 'stylesheet');
    fileref.setAttribute('type', 'text/css');
    fileref.setAttribute('href', url);
    return fileref;
}
exports.createLinkElement = createLinkElement;
function createScriptElement(url, crossorigin) {
    var fileref = document.createElement('script');
    fileref.setAttribute('type', 'text/javascript');
    fileref.setAttribute('src', url);
    if (crossorigin) {
        fileref.setAttribute('crossorigin', 'anonymous');
    }
    return fileref;
}
exports.createScriptElement = createScriptElement;
function tagAppender(url, filetype, crossorigin) {
    var styleSheets = document.styleSheets;
    return new Promise(function (resolve, reject) {
        // @ts-expect-error
        if (window.requirejs && filetype === 'js') {
            // @ts-expect-error
            window.requirejs([url], resolve, reject);
            return;
        }
        var fileref = filetype === 'css' ? createLinkElement(url) : createScriptElement(url, crossorigin);
        var done = false;
        document.getElementsByTagName('head')[0].appendChild(fileref);
        fileref.onerror = function () {
            // @ts-expect-error
            fileref.onerror = fileref.onload = fileref.onreadystatechange = null;
            (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.FileAppenderLoadError(url));
            reject(new Error("Could not load URL ".concat(url)));
        };
        // @ts-expect-error
        fileref.onload = fileref.onreadystatechange = function () {
            if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
                done = true;
                // @ts-expect-error
                fileref.onerror = fileref.onload = fileref.onreadystatechange = null;
                resolve();
            }
        };
        if (filetype === 'css' &&
            navigator.userAgent.match(' Safari/') &&
            !navigator.userAgent.match(' Chrom') &&
            navigator.userAgent.match(' Version/5.')) {
            var attempts_1 = 20;
            var interval_1 = setInterval(function () {
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (var i = 0; i < styleSheets.length; i++) {
                    if (noprotocol("".concat(styleSheets[i].href)) === noprotocol(url)) {
                        clearInterval(interval_1);
                        // @ts-expect-error
                        fileref.onload();
                        return;
                    }
                }
                if (--attempts_1 === 0) {
                    clearInterval(interval_1);
                    // @ts-expect-error
                    fileref.onerror();
                }
            }, 50);
        }
    });
}
exports.tagAppender = tagAppender;
function append(file, crossorigin) {
    return tagAppender(file, file.split('.').pop(), crossorigin);
}
function onCatch(error, optional) {
    if (optional === void 0) { optional = false; }
    return optional ? Promise.resolve() : Promise.reject(error);
}
function appendEntry(entry, crossorigin) {
    if (typeof entry === 'object') {
        var optional_1 = entry.optional, url = entry.url;
        return append(url, crossorigin).catch(function (err) { return onCatch(err, optional_1); });
    }
    return append(entry, crossorigin).catch(function (err) { return onCatch(err); });
}
function filesAppender(entries, crossorigin) {
    return Promise.all(entries.map(function (entry) {
        if (Array.isArray(entry)) {
            return entry.reduce(function (promise, _entry) { return promise.then(function () { return appendEntry(_entry, crossorigin); }); }, Promise.resolve());
        }
        return appendEntry(entry, crossorigin);
    }));
}
exports.filesAppender = filesAppender;
var getStyleSheetLinks = function (document) {
    return tslib_1.__spreadArray([], tslib_1.__read(document.querySelectorAll('link')), false).filter(function (link) { return link.rel === 'stylesheet' && link.href; })
        .reduceRight(function (acc, curr) {
        var _a;
        return (tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[noprotocol(curr.href)] = curr, _a)));
    }, {});
};
var toUrlString = function (file) { return (typeof file === 'object' ? file.url : file); };
var getStyleSheetUrls = function (files) {
    return []
        .concat.apply([], tslib_1.__spreadArray([], tslib_1.__read(files), false)).map(toUrlString)
        .filter(function (url) { return url.endsWith('.css'); })
        .map(noprotocol);
};
function unloadStyles(document, files) {
    var links = getStyleSheetLinks(document);
    getStyleSheetUrls(files).forEach(function (file) {
        var link = links[file];
        if (link) {
            link.parentNode.removeChild(link);
        }
    });
}
exports.unloadStyles = unloadStyles;
//# sourceMappingURL=tag-appender.js.map